import { render, staticRenderFns } from "./recommends.vue?vue&type=template&id=9822bfca&"
import script from "./recommends.vue?vue&type=script&lang=js&"
export * from "./recommends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports